import { shuffle } from '../../huntingWords';
import { insertWordBasedOnStrategy } from '../insertion/insertBasedOnStrategy';
import { getEnabledDirections, isAllDiagonalEnabled, resolveValidDirection } from './directionUtils';

export class PercentageStrategy {
  constructor(engine) {
    this.engine = engine;
  }

  generateDirectionList(percentages, totalWords) {
    const total = Object.values(percentages).reduce((sum, v) => sum + v, 0);
    const result = [];
    Object.entries(percentages).forEach(([direction, value]) => {
      const percent = total === 0 ? 0 : (value / total) * 100;
      const count = Math.round((percent / 100) * totalWords);
      for (let i = 0; i < count; i += 1) result.push(direction);
    });
    return result;
  }

  place(wordsList, game) {
    const enabledDirections = getEnabledDirections(this.engine.model.settings);
    const hasAllDiagonalDirections = isAllDiagonalEnabled(enabledDirections);
    const { rows, columns } = this.engine.model;
    const { percentages } = this.engine.model.settings;

    const directionQueue = this.generateDirectionList(percentages, wordsList.length);
    shuffle(directionQueue);
    shuffle(wordsList);

    wordsList.forEach((word, index) => {
      const pickedDirection = directionQueue[index] || enabledDirections[0];

      const direction = resolveValidDirection(
        word,
        pickedDirection,
        enabledDirections,
        rows,
        columns,
      );

      if (direction === null) {
        this.engine.state.addUnplaced(word);
        return;
      }

      insertWordBasedOnStrategy(
        this.engine,
        word,
        direction,
        hasAllDiagonalDirections,
        game,
      );
    });
  }
}
